export enum PulseTimelineEntryType {
	TAGGED_USER = 'taggedUser',
	TRANSCRIPTION = 'transcription'
}
